export default __webpack_public_path__ + "static/media/26.1fc9b9c4.jpg";